import Button from 'assets/components/button/Button';
import ThemeButtonCircle from 'assets/components/button/themes/Theme.Button.Circle';
import DataMap from 'assets/components/dataMap/DataMap';
import DataObjectMap from 'assets/components/dataObjectMap/DataObjectMap';
import ThemeTableSimple from 'assets/components/table/themes/Theme.Table.Simple';
import useApi from 'assets/hooks/api/useApi';
import { getLocales } from 'assets/locales/Locale';
import ValueDisplay from 'assets/templates/valueDisplay/ValueDisplay';
import Theme from 'assets/themes/Theme.Common';
import AuditLog from 'models/audit/auditLog/Model.AuditLog';
import { Fragment } from 'react';
import { useClaimEdit } from '../ClaimEdit.Hooks';
import Box from 'assets/components/box/Box';
import ThemeWrapperStack from 'assets/themes/wrappers/Theme.Wrapper.Stack';

export default function ClaimEditLogs() {
  const { lang, translate } = getLocales();
  const { permissions, claim, pageRouter } = useClaimEdit();
  const hasAccess = claim?.id && (permissions?.CLAIM_ADMIN || permissions?.VIEW_CLAIM_LOGS);

  const listLogsApi = useApi({
    action: AuditLog.claimAuditLogList,
    body: {
      claimId: claim?.id,
    },
    wait: true,
  });
  const logs = listLogsApi.payload?.data;
  function loadLogs() {
    if (hasAccess) {
      const claimId = claim?.id ?? Number(pageRouter.params?.claimId);
      if (claimId) listLogsApi.execute({ claimId });
      else listLogsApi.execute((b) => b);
    }
  }

  return (!listLogsApi?.payload?.data?.length && listLogsApi?.apiCounter === 0) || listLogsApi?.isExecuting ? (
    <Box class={ThemeWrapperStack}>
      <h2 style={{ marginRight: 'auto' }}>{lang.logs}</h2>
      <Button
        onClick={loadLogs}
        class={ThemeButtonCircle}
        isLoading={listLogsApi?.isExecuting}
        active={hasAccess}
        disabled={!hasAccess}
      >
        {lang.loadLogs}
      </Button>
    </Box>
  ) : (
    <>
      <h2>{lang.logs}</h2>
      <table className={ThemeTableSimple}>
        <DataMap
          data={logs}
          render={({ data: auditLog }) => (
            <Fragment key={auditLog.id}>
              <thead>
                <tr>
                  <th colSpan={2}>
                    {auditLog.application?.name} ({translate(auditLog.permissionKey)})
                  </th>
                  <th style={{ textAlign: 'left' }}>{auditLog.changedAtUtcParsed}</th>
                </tr>
                <tr>
                  <th>{lang.property}</th>
                  <th>{lang.oldValue}</th>
                  <th style={{ textAlign: 'left' }}>{lang.newValue}</th>
                </tr>
              </thead>
              <tbody>
                <DataObjectMap
                  data={auditLog.changes}
                  render={({ data, key }) => (
                    <tr key={key} style={{ marginBottom: Theme.Size.M }}>
                      <td>{lang[key] || key}</td>
                      <td>
                        {auditLog?.isChange && data.old ? (
                          <ValueDisplay
                            value={data.old}
                            subcomponents={{
                              listValue: {
                                style: { backgroundColor: Theme.Color.error },
                              },
                            }}
                          />
                        ) : (
                          'N/A'
                        )}
                      </td>
                      <td style={{ textAlign: 'left' }}>
                        {data.current && (
                          <ValueDisplay
                            value={data.current}
                            subcomponents={{
                              listValue: {
                                style: { backgroundColor: Theme.Color.success },
                              },
                            }}
                          />
                        )}
                      </td>
                    </tr>
                  )}
                />
              </tbody>
            </Fragment>
          )}
        />
      </table>
    </>
  );
}
